import { Form, Switch } from "antd";
import { RuleObject } from "antd/lib/form";
import HrText from "components/HrText/HrText";

import "./AssistedPrivacyAutorizations.css";
import { validateSwitch } from "utils/Validate";
import { Enhanced, IReactComponentBase } from "utils/ReactUtils";
import CustomTranslation from "components/CustomTranslation/CustomTranslation";

const AssistedPrivacyAutorizations: React.FC< IReactComponentBase> = ({t}) => {

	const config = window.CONFIG.REACT_APP_CONSENSI;
	return (
		<>
			<HrText text={t("assistito.privacy.title")} />

			<div className="privacy">
				{config.PRIVACY.ENABLED && (
					<div className="switch-button">
						<span className="text-cb text">{t("assistito.privacy.generale") + (config.PRIVACY.REQUIRED ? " (*)" : "")}</span>

						<Form.Item
							name="Privacy"
							valuePropName="checked"
							initialValue={false}
							rules={[
								{ required: config.PRIVACY.REQUIRED, message: t("register.requiredMessages.privacy") },
								{
									validator: async (rule: RuleObject, value: any, callback: any) => {
										if (config.PRIVACY.REQUIRED) await validateSwitch(rule, value, callback, "*");
									},
								},
							]}
						>
							<Switch className="toggle"/>
						</Form.Item>
					</div>
				)}
				{config.COMUNICAZIONI_MMG.ENABLED && (
					<div className="switch-button">
						<span className="text-cb text">{t("assistito.privacy.mmg") + (config.COMUNICAZIONI_MMG.REQUIRED ? " (*)" : "")}</span>

						<Form.Item
							name="ComunicazioniMMG"
							valuePropName="checked"
							initialValue={false}
							rules={[
								{ required: config.COMUNICAZIONI_MMG.REQUIRED, message: t("register.requiredMessages.privacy") },
								{
									validator: async (rule: RuleObject, value: any, callback: any) => {
										if (config.COMUNICAZIONI_MMG.REQUIRED) await validateSwitch(rule, value, callback, "*");
									},
								},
							]}
						>
							<Switch className="toggle"/>
						</Form.Item>
					</div>
				)}

				{config.COMUNICAZIONI_SERVIZIO.ENABLED && (
					<div className="switch-button">
						<span className="text-cb text">{t("assistito.privacy.servizio") + (config.COMUNICAZIONI_SERVIZIO.REQUIRED ? " (*)" : "")}</span>

						<Form.Item
							name="ComunicazioniServizio"
							valuePropName="checked"
							initialValue={false}
							rules={[
								{ required: config.COMUNICAZIONI_SERVIZIO.REQUIRED, message: t("register.requiredMessages.privacy") },
								{
									validator: async (rule: RuleObject, value: any, callback: any) => {
										if (config.COMUNICAZIONI_SERVIZIO.REQUIRED) await validateSwitch(rule, value, callback, "*");
									},
								},
							]}
						>
							<Switch className="toggle"/>
						</Form.Item>
					</div>
				)}

				{config.MARKETING.ENABLED && (
					<div className="switch-button">
						<div>
							<span className="text-cb text">{t("assistito.privacy.marketing") + (config.MARKETING.REQUIRED ? " (*)" : "")}</span>
						</div>
						<Form.Item
							name="Marketing"
							initialValue={false}
							valuePropName="checked"
							rules={[
								{ required: config.MARKETING.REQUIRED, message: t("register.requiredMessages.privacy") },
								{
									validator: async (rule: RuleObject, value: any, callback: any) => {
										if (config.MARKETING.REQUIRED) await validateSwitch(rule, value, callback, "*");
									},
								},
							]}
						>
							<Switch className="toggle"/>
						</Form.Item>
					</div>
				)}

				{config.DOC_SANITARI.ENABLED && (
					<div className="switch-button">
						<div>
							<span className="text-cb text">{t("assistito.privacy.docSanitari") + (config.DOC_SANITARI.REQUIRED ? " (*)" : "")}</span>
						</div>
						<Form.Item
							name="DocSanitari"
							initialValue={false}
							valuePropName="checked"
							rules={[
								{ required: config.DOC_SANITARI.REQUIRED, message: t("register.requiredMessages.privacy") },
								{
									validator: async (rule: RuleObject, value: any, callback: any) => {
										if (config.DOC_SANITARI.REQUIRED) await validateSwitch(rule, value, callback, "*");
									},
								},
							]}
						>
							<Switch className="toggle"/>
						</Form.Item>
					</div>
				)}

				{config.TERZI.ENABLED && (
					<div className="switch-button">
						<div>
							<span className="text-cb text">{t("assistito.privacy.terzi") + (config.TERZI.REQUIRED ? " (*)" : "")}</span>
						</div>
						<Form.Item
							name="Terzi"
							initialValue={false}
							valuePropName="checked"
							rules={[
								{ required: config.TERZI.REQUIRED, message: t("register.requiredMessages.privacy") },
								{
									validator: async (rule: RuleObject, value: any, callback: any) => {
										if (config.TERZI.REQUIRED) await validateSwitch(rule, value, callback, "*");
									},
								},
							]}
						>
							<Switch className="toggle"/>
						</Form.Item>
					</div>
				)}

				{
					<>
						<br />
						<div className="footer">
							<span>
								<CustomTranslation t={t} i18Key={"assistedPrivacyAutorizations.text"} type="condizioniVendita"></CustomTranslation>
							</span>
						</div>
					</>
				}
			</div>
		</>
	);
};

export default Enhanced( AssistedPrivacyAutorizations,{componentNamespace:"AssistedPrivacyAutorizations"});
